import { Box, Flex, Text } from "@chakra-ui/react";
import { useHeader } from "../../hooks/useHeader";

/**
 * @typedef {Object} Props
 * @property {string} title
 * @property {import("react").ReactNode} children
 *
 * @param {Props} props
 */
function StepLayout({ title, children }) {
  const { headerHeight } = useHeader();

  return (
    <Flex flexDir="column-reverse">
      <Box>{children}</Box>

      <Text
        fontSize="1.25rem"
        fontWeight={700}
        position="sticky"
        top={`${headerHeight}px`}
        backgroundColor="#fff"
        borderBottomWidth="1px"
        borderTopRadius="1rem"
        p={{ base: ".5rem 1rem", sm: "1rem" }}>
        {title}
      </Text>
    </Flex>
  );
}

export default StepLayout;
